import {
  GET_MANAGE_ORGANIZATION_INFO,
} from "./types";

export default {
  [GET_MANAGE_ORGANIZATION_INFO]: (state, manageOrganizationInfo) => {
    state.manageOrganization = manageOrganizationInfo;
  },
};
